var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 134,
    viewBox: "0 0 140 134",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_640_1649)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_640_1649",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0.92041,
    width: 140,
    height: 133,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    y: 0.92041,
    width: 140,
    height: 133
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.946 1.92041H40.123C16.732 1.92041 1 17.4883 1 40.6439V94.0914C1 117.182 16.732 132.743 40.123 132.743H99.946C123.337 132.743 139 117.182 139 94.0914V40.6439C139 17.4883 123.337 1.92041 99.946 1.92041Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99.946 1.92041H40.123C16.732 1.92041 1 17.4883 1 40.6439V94.0914C1 117.182 16.732 132.743 40.123 132.743H99.946C123.337 132.743 139 117.182 139 94.0914V40.6439C139 17.4883 123.337 1.92041 99.946 1.92041Z",
    fill: "#E74444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.946 0.92041C99.3937 0.92041 98.946 1.36813 98.946 1.92041C98.946 2.47269 99.3937 2.92041 99.946 2.92041V0.92041ZM99.946 0.92041H40.123V2.92041H99.946V0.92041ZM40.123 0.92041C28.2012 0.92041 18.1553 4.89177 11.0864 11.888C4.01662 18.8852 0 28.8335 0 40.6439H2C2 29.2986 5.84938 19.8852 12.4933 13.3095C19.1382 6.73299 28.6538 2.92041 40.123 2.92041V0.92041ZM0 40.6439V94.0914H2V40.6439H0ZM0 94.0914C0 105.87 4.01713 115.8 11.0869 122.787C18.1558 129.773 28.2013 133.743 40.123 133.743V131.743C28.6537 131.743 19.1377 127.932 12.4928 121.365C5.84887 114.799 2 105.403 2 94.0914H0ZM40.123 133.743H99.946V131.743H40.123V133.743ZM99.946 133.743C111.868 133.743 121.897 129.773 128.948 122.786C136.001 115.799 140 105.869 140 94.0914H138C138 105.404 134.168 114.8 127.541 121.366C120.913 127.932 111.415 131.743 99.946 131.743V133.743ZM140 94.0914V40.6439H138V94.0914H140ZM140 40.6439C140 28.8348 136.001 18.8866 128.949 11.8889C121.897 4.8919 111.868 0.92041 99.946 0.92041V2.92041C111.415 2.92041 120.913 6.73285 127.54 13.3087C134.167 19.8838 138 29.2973 138 40.6439H140Z",
    fill: "url(#paint0_linear_640_1649)",
    mask: "url(#path-1-outside-1_640_1649)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bd_640_1649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.7664 78.9184C93.1124 81.1424 93.1124 84.74 90.7664 86.9575C89.5934 88.0695 88.0754 88.6647 86.4884 88.6647C84.9704 88.6647 83.4524 88.1414 82.2794 86.9575L69.9974 75.3862L57.7154 86.9575C56.5424 88.0695 55.0244 88.6647 53.4374 88.6647C51.9194 88.6647 50.3324 88.0695 49.1594 86.9575C46.8134 84.74 46.8134 81.1424 49.1594 78.853L61.4414 67.2752L49.1594 55.6255C46.8134 53.408 46.8134 49.745 49.1594 47.521C51.5054 45.2905 55.3004 45.2905 57.7154 47.521L69.9974 59.1577L82.2104 47.521C84.6254 45.2905 88.4204 45.2905 90.7664 47.521C93.1124 49.745 93.1124 53.408 90.7664 55.6255L78.4844 67.2752L90.7664 78.9184Z",
    fill: "url(#paint1_linear_640_1649)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2794 86.9575C83.4524 88.1414 84.9704 88.6647 86.4884 88.6647C88.0754 88.6647 89.5934 88.0695 90.7664 86.9575C93.1124 84.74 93.1124 81.1424 90.7664 78.9184L82.2794 86.9575ZM82.2794 86.9575L69.9974 75.3862M82.2794 86.9575L69.9974 75.3862M69.9974 75.3862L57.7154 86.9575M69.9974 75.3862L57.7154 86.9575M57.7154 86.9575C56.5424 88.0695 55.0244 88.6647 53.4374 88.6647C51.9194 88.6647 50.3324 88.0695 49.1594 86.9575H57.7154ZM90.629 86.8121L90.6288 86.8123C89.4932 87.8889 88.0245 88.4647 86.4884 88.4647C85.0167 88.4647 83.5522 87.958 82.4215 86.8167L82.4216 86.8166L82.4165 86.8119L70.1345 75.2407L69.9974 75.1114L69.8603 75.2407L57.5783 86.8119L57.5778 86.8123C56.4422 87.8889 54.9736 88.4647 53.4374 88.4647C51.9691 88.4647 50.4318 87.8881 49.297 86.8123L49.2968 86.8121C47.036 84.6752 47.0322 81.2095 49.2979 78.9973C49.2983 78.9969 49.2987 78.9965 49.2991 78.9962L61.5786 67.4208L61.7325 67.2757L61.579 67.1301L49.297 55.4804L49.2968 55.4801C47.0344 53.3417 47.0341 49.8114 49.297 47.6662L49.2972 47.666C51.5646 45.5102 55.2392 45.5072 57.5788 47.6671C57.5791 47.6674 57.5794 47.6677 57.5797 47.668L69.8598 59.3029L69.9978 59.4336L70.1354 59.3025L82.3461 47.668C82.3464 47.6676 82.3468 47.6673 82.3471 47.667C84.6867 45.5072 88.3612 45.5102 90.6286 47.666L90.6288 47.6662C92.8917 49.8114 92.8914 53.3417 90.629 55.4801L90.6288 55.4804L78.3468 67.1301L78.1937 67.2753L78.3468 67.4204L90.6288 79.0636C92.8917 81.2088 92.8914 84.6737 90.629 86.8121Z",
    stroke: "url(#paint2_linear_640_1649)",
    strokeWidth: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_640_1649",
    x: -24,
    y: -23.0796,
    width: 188,
    height: 180.822,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_640_1649"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_640_1649",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bd_640_1649",
    x: 32.3999,
    y: 30.8481,
    width: 75.126,
    height: 72.8164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_640_1649"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.321569 0 0 0 0 0.54902 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_640_1649",
    result: "effect2_dropShadow_640_1649"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_640_1649",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_640_1649",
    x1: 22.9674,
    y1: 17.1614,
    x2: 123.421,
    y2: 131.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_640_1649",
    x1: 89.3265,
    y1: 53.58,
    x2: 39.0663,
    y2: 55.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_640_1649",
    x1: 54.5832,
    y1: 50.8363,
    x2: 81.5596,
    y2: 86.0494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseImg);
export default __webpack_public_path__ + "static/media/closeImg.436ac5bd6e0f1e91cf5f44fb036e2d98.svg";
export { ForwardRef as ReactComponent };